import { useState, useEffect, useReducer, useMemo } from 'react'
import { get } from '../modules/fetch'
import syncStatus from './useData'
import stringify from 'fast-json-stable-stringify'
import provider from '../modules/provider'

const checkConditions = conditions => {
    // console.log('checking conditions', conditions)
    if (typeof conditions === 'undefined') {
        return true
    } else {
        if (Array.isArray(conditions)) {
            return conditions.reduce((acc, item) => {
                if (!!item === false) {
                    acc = false
                }
                return acc
            }, true)
        } else {
            return !!conditions
        }
    }
}

const dataFetchReducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_INIT':
            return { ...state, data: undefined, isLoading: true, isError: false, isReady: false }
        case 'FETCH_SUCCESS':
            return { ...state, data: action.payload, isLoading: false, isError: false, isReady: true }
        case 'FETCH_FAILURE':
            return { ...state, isLoading: false, isError: action.payload, isReady: false }
        default:
            throw new Error()
    }
}
const useFetch = ({ url, params, initialData, transform }, conditions) => {
    typeof params === 'function' && (transform = params)
    typeof initialData === 'function' && (transform = initialData)
    const [current_url, setCurrentUrl] = useState(url)
    const [current_params, setParams] = useState(params)
    const [JSONPrevParams, setJSONPrevParams] = useState(params)
    const JSONParams = stringify(params)
    const key = 'fetched-' + current_url + JSONParams
    // As the params object might not be referentially stable, we compare its equivalence using a stable stringify
    if (JSONParams !== JSONPrevParams) {
        setParams(params)
        setJSONPrevParams(JSONParams)
    }
    if (url !== current_url) {
        setCurrentUrl(url)
    }

    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: false,
        isError: false,
        data: initialData
    })
    let didCancel = false

    // trying to use memo in case conditions are ref-stable, will be executed each time otherwise
    const resolved_conditions = useMemo(() => checkConditions(conditions), [conditions])

    const doFetch = () => {
        // console.log('calling with url=', url)
        if (current_url && resolved_conditions) {
            if (!syncStatus[key]) {
                // console.log('CREATING', key)
                syncStatus[key] = { isLoading: false }
            }
            if (!syncStatus[key].isLoading) {
                syncStatus[key].isLoading = true
                dispatch({ type: 'FETCH_INIT' })
                get(url, params)
                    .then(r => {
                        !didCancel && dispatch({ type: 'FETCH_SUCCESS', url, payload: (transform && transform(r)) || r })
                        syncStatus[key].isLoading = false
                    })
                    .catch(error => {
                        console.error({ error })
                        !didCancel && dispatch({ type: 'FETCH_FAILURE', payload: error })
                        syncStatus[key].isLoading = false
                    })
            }
        }
    }

    useEffect(() => {
        // console.log('useEffect')
        didCancel = false
        doFetch()
        return () => {
            didCancel = true
        }
    }, [current_url, current_params, resolved_conditions])

    const refresh = () => {
        doFetch()
    }
    const fetch = fetchProps => {
        // TODO: set local state according to fetchProps
        // needed?
        doFetch()
    }

    return { ...state, refresh, fetch }
}

export default useFetch
